import EmailUs from 'components/Content/CustomerService/EmailUs/EmailUs';

export default EmailUs;
